var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSquareAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9305 1.6665H6.94714C3.9138 1.6665 2.10547 3.47484 2.10547 6.50817V13.4832C2.10547 16.5248 3.9138 18.3332 6.94714 18.3332H13.9221C16.9555 18.3332 18.7638 16.5248 18.7638 13.4915V6.50817C18.7721 3.47484 16.9638 1.6665 13.9305 1.6665ZM15.4388 10.6248H11.0638V14.9998C11.0638 15.3415 10.7805 15.6248 10.4388 15.6248C10.0971 15.6248 9.8138 15.3415 9.8138 14.9998V10.6248H5.4388C5.09714 10.6248 4.8138 10.3415 4.8138 9.99984C4.8138 9.65817 5.09714 9.37484 5.4388 9.37484H9.8138V4.99984C9.8138 4.65817 10.0971 4.37484 10.4388 4.37484C10.7805 4.37484 11.0638 4.65817 11.0638 4.99984V9.37484H15.4388C15.7805 9.37484 16.0638 9.65817 16.0638 9.99984C16.0638 10.3415 15.7805 10.6248 15.4388 10.6248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareAdd);
export default __webpack_public_path__ + "static/media/icon_square_add.14047ceff840880f16dccbd07e4286c5.svg";
export { ForwardRef as ReactComponent };